import { isInViewportCenter } from "../helper/helper";

export function initMobileHover() {
    let mobileHovers = Array.from(document.getElementsByClassName('mobile-hover'));

    if (mobileHovers != null && mobileHovers != 'undefined') {
        mobileHovers.forEach(function (hover) {
          if (window.innerWidth <= 1023) {
            if (isInViewportCenter(hover)) {
              hover.classList.add('mobile-hover-active');
            } else {
              hover.classList.remove('mobile-hover-active');
            }
          }

          document.addEventListener('scroll', function() {
              if (window.innerWidth <= 1023) {
                if (isInViewportCenter(hover)) {
                  hover.classList.add('mobile-hover-active');
                } else {
                  hover.classList.remove('mobile-hover-active');
                }
              }
          });
        });
    }


}